<template>
  <div>
    <CellGroup>
      <Field name="slider" label="考试时长">
        <template #input>
          <Slider
            v-model="examTime._value"
            :min="examTime._min ? examTime._min : 0"
            :max="examTime._max"
            @drag-end="emit('handleDragEnd')"
          />
        </template>
        <template #button>
          <div class="SilderClass">{{ ExamTimeToMin }}</div>
        </template>
      </Field>
      <Field name="slider" label="考试分数">
        <template #input>
          <Slider
            v-model="examScore._value"
            :min="0"
            :max="examScore._max"
            @drag-end="emit('handleDragEnd')"
          />
        </template>
        <template #button>
          <div class="SilderClass">{{ ExamScoreToStr }}</div>
        </template>
      </Field>
    </CellGroup>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { Slider, Field, CellGroup } from "vant";
const emit = defineEmits(["handleDragEnd"]);
const props = defineProps({
  examTime: {
    _value: Number,
    _max: Number,
  },
  examScore: {
    _value: Number,
    _max: Number,
  },
});
const examTime = ref(props.examTime);
const examScore = ref(props.examScore);

// 秒转换为分钟和秒
const ExamTimeToMin = computed({
  get() {
    const minute = Math.floor(examTime.value._value / 60);
    const second = examTime.value._value % 60;
    return `${minute}分${second}秒`;
  },
});
const ExamScoreToStr = computed({
  get() {
    return `${examScore.value._value}分`;
  },
});
</script>
